"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Staking__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "source",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "DelegationAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "source",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "DelegationRemoved",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "source",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "UnbondCancelled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "source",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "enum UnbondType",
                name: "_type",
                type: "uint8",
            },
        ],
        name: "UnbondRequested",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "source",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "UnbondWithdrawn",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "addDelegation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
        ],
        name: "addIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "checkDelegateLimitation",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "delegateToIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "delegation",
        outputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAfter",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "indexerLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "indexerLeverageLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "indexerNo",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "indexers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_lockPeriod",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_unbondFeeRate",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
        ],
        name: "isEmptyDelegation",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "lockedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxUnbondingRequest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
        ],
        name: "reflectEraUpdate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "removeDelegation",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
        ],
        name: "removeIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_unbondReqId",
                type: "uint256",
            },
        ],
        name: "removeUnbondingAmount",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_indexerLeverageLimit",
                type: "uint256",
            },
        ],
        name: "setIndexerLeverageLimit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_lockPeriod",
                type: "uint256",
            },
        ],
        name: "setLockPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "maxNum",
                type: "uint256",
            },
        ],
        name: "setMaxUnbondingRequest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
        ],
        name: "setSettings",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_unbondFeeRate",
                type: "uint256",
            },
        ],
        name: "setUnbondFeeRateBP",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "slashIndexer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakingIndexerLengths",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "stakingIndexerNos",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "stakingIndexers",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "enum UnbondType",
                name: "_type",
                type: "uint8",
            },
        ],
        name: "startUnbond",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "totalStakingAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "era",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAt",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "valueAfter",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "unbondCommission",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unbondFeeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "unbondingAmount",
        outputs: [
            {
                internalType: "address",
                name: "indexer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startTime",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "unbondingLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_source",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_index",
                type: "uint256",
            },
        ],
        name: "withdrawARequest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "withdrawnLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b506158f680620000216000396000f3fe608060405234801561001057600080fd5b50600436106102695760003560e01c80638da5cb5b11610151578063b939ae1d116100c3578063d9e4243511610087578063d9e4243514610748578063dde28b4814610764578063dea25a9414610794578063e06174e4146107b2578063edd32928146107d0578063f2fde38b1461080057610269565b8063b939ae1d14610692578063bf709149146106ae578063c1fcdd72146106ca578063cce7f9b0146106fc578063d87db8851461071857610269565b8063a0770b7311610115578063a0770b73146105ae578063a153e708146105ca578063a1f00b03146105fa578063a64285d214610616578063b638f5da14610632578063b6a7b0d11461066257610269565b80638da5cb5b1461051c578063907a11cc1461053a5780639f5795e114610558578063a01d3c2c14610574578063a0719d1d1461059057610269565b8063481f7912116101ea57806369b985b5116101ae57806369b985b51461045c578063715018a614610478578063779972da146104825780637a1ac61e1461049e5780637d52ab65146104ba5780638715937f146104ea57610269565b8063481f7912146103ca578063489e99f2146103e65780634aa83d0e14610402578063509d1d1714610420578063538ba4f91461043e57610269565b80632fff7594116102315780632fff75941461033c5780633173b2c1146103585780633b77fd28146103745780633c004ae5146103905780633fd8b02f146103ac57610269565b8063044609031461026e578063046d33071461028c57806308def162146102be5780630b58dfa8146102dc578063186543ab1461030c575b600080fd5b61027661081c565b60405161028391906146ee565b60405180910390f35b6102a660048036038101906102a1919061476c565b610823565b6040516102b5939291906147ac565b60405180910390f35b6102c661085a565b6040516102d391906146ee565b60405180910390f35b6102f660048036038101906102f191906147e3565b610863565b60405161030391906146ee565b60405180910390f35b610326600480360381019061032191906147e3565b61087b565b60405161033391906146ee565b60405180910390f35b610356600480360381019061035191906147e3565b610893565b005b610372600480360381019061036d919061483c565b610a46565b005b61038e6004803603810190610389919061488f565b610c75565b005b6103aa60048036038101906103a591906148f4565b61119b565b005b6103b4611666565b6040516103c191906146ee565b60405180910390f35b6103e460048036038101906103df919061488f565b61166c565b005b61040060048036038101906103fb919061495b565b61188a565b005b61040a611910565b60405161041791906146ee565b60405180910390f35b610428611918565b60405161043591906146ee565b60405180910390f35b61044661191e565b6040516104539190614997565b60405180910390f35b6104766004803603810190610471919061488f565b611923565b005b610480611aed565b005b61049c6004803603810190610497919061495b565b611b75565b005b6104b860048036038101906104b391906149f0565b611bfb565b005b6104d460048036038101906104cf91906147e3565b611d49565b6040516104e191906146ee565b60405180910390f35b61050460048036038101906104ff91906147e3565b611d61565b604051610513939291906147ac565b60405180910390f35b610524611d8b565b6040516105319190614997565b60405180910390f35b610542611db5565b60405161054f91906146ee565b60405180910390f35b610572600480360381019061056d919061476c565b611dbb565b005b61058e60048036038101906105899190614a43565b611f92565b005b610598612052565b6040516105a591906146ee565b60405180910390f35b6105c860048036038101906105c3919061495b565b612058565b005b6105e460048036038101906105df91906147e3565b612123565b6040516105f191906146ee565b60405180910390f35b610614600480360381019061060f91906147e3565b61213b565b005b610630600480360381019061062b919061488f565b6123ea565b005b61064c600480360381019061064791906147e3565b612c1a565b60405161065991906146ee565b60405180910390f35b61067c6004803603810190610677919061495b565b612c32565b6040516106899190614997565b60405180910390f35b6106ac60048036038101906106a7919061483c565b612c65565b005b6106c860048036038101906106c3919061488f565b612fca565b005b6106e460048036038101906106df919061488f565b6133fd565b6040516106f393929190614a70565b60405180910390f35b6107166004803603810190610711919061495b565b613454565b005b610732600480360381019061072d919061476c565b6134da565b60405161073f9190614ac2565b60405180910390f35b610762600480360381019061075d919061483c565b6135f1565b005b61077e6004803603810190610779919061476c565b613eb3565b60405161078b91906146ee565b60405180910390f35b61079c613ed8565b6040516107a991906146ee565b60405180910390f35b6107ba613ede565b6040516107c79190614b3c565b60405180910390f35b6107ea60048036038101906107e5919061488f565b613f04565b6040516107f79190614997565b60405180910390f35b61081a600480360381019061081591906147e3565b613f46565b005b620f424081565b6071602052816000526040600020602052806000526040600020600091509150508060000154908060010154908060020154905083565b64e8d4a5100081565b60756020528060005260406000206000915090505481565b606f6020528060005260406000206000915090505481565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015610900573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109249190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610991576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161098890614bf6565b60405180910390fd5b80606b6000606954815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550606954606c60008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555060696000815480929190610a3e90614c45565b919050555050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015610ab3573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ad79190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610b44576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610b3b90614bf6565b60405180910390fd5b610c01833083606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663afc1aaca6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610bb7573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610bdb9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff1661403d909392919063ffffffff16565b3073ffffffffffffffffffffffffffffffffffffffff1663d9e424358484846040518463ffffffff1660e01b8152600401610c3e93929190614c8d565b600060405180830381600087803b158015610c5857600080fd5b505af1158015610c6c573d6000803e3d6000fd5b50505050505050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015610ce2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d069190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614610d73576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610d6a90614bf6565b60405180910390fd5b6000606e60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008381526020019081526020016000206040518060600160405290816000820160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001600182015481526020016002820154815250509050606e60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000838152602001908152602001600020600080820160006101000a81549073ffffffffffffffffffffffffffffffffffffffff02191690556001820160009055600282016000905550506000607060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054905060006001606f60008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054610f589190614cc4565b90508184036110415760008290505b81811161103b576000606e60008873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000838152602001908152602001600020600101540361102357607060008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061101990614c45565b9190505550611028565b61103b565b808061103390614c45565b915050610f67565b50611125565b8084036111245760008190505b828110611122576000606e60008873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000838152602001908152602001600020600101540361110a57606f60008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061110090614cf8565b919050555061110f565b611122565b808061111a90614cf8565b91505061104e565b505b5b826000015173ffffffffffffffffffffffffffffffffffffffff168573ffffffffffffffffffffffffffffffffffffffff167fd45b991ece355f89d16e71704a644e17e2e7ec4b839d471b6ef7e391c19ca4c585602001518760405161118c929190614d21565b60405180910390a35050505050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015611208573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061122c9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16148061129057503073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16145b6112cf576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016112c690614d96565b60405180910390fd5b6000606f60008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205490506000600381111561132757611326614db6565b5b82600381111561133a57611339614db6565b5b036113da576001606a5461134e9190614cc4565b607060008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054826113999190614cc4565b106113d9576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016113d090614e31565b60405180910390fd5b5b600260038111156113ee576113ed614db6565b5b82600381111561140157611400614db6565b5b14611476573073ffffffffffffffffffffffffffffffffffffffff1663b939ae1d8686866040518463ffffffff1660e01b815260040161144393929190614c8d565b600060405180830381600087803b15801561145d57600080fd5b505af1158015611471573d6000803e3d6000fd5b505050505b606a54607060008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054826114c49190614cc4565b036114e0576003915080806114d890614cf8565b915050611536565b606f60008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061153090614c45565b91905055505b6000606e60008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600083815260200190815260200160002090508381600101600082825461159e9190614e51565b92505081905550428160020181905550848160000160006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508473ffffffffffffffffffffffffffffffffffffffff168673ffffffffffffffffffffffffffffffffffffffff167ffa2c36e9278b80f2b6de66b552c21f7dce987269782d8688015e794aac43a64d8360010154858760405161165693929190614eef565b60405180910390a3505050505050565b60685481565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa1580156116d9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116fd9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161461176a576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161176190614bf6565b60405180910390fd5b80606d60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600201546117b89190614e51565b606654607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600201546118459190614f26565b1015611886576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161187d90614fcc565b60405180910390fd5b5050565b6118926140c6565b73ffffffffffffffffffffffffffffffffffffffff166118b0611d8b565b73ffffffffffffffffffffffffffffffffffffffff1614611906576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016118fd90615038565b60405180910390fd5b80606a8190555050565b633b9aca0081565b606a5481565b600081565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166373589db36040518163ffffffff1660e01b8152600401602060405180830381865afa158015611990573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906119b49190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614611a21576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611a18906150a4565b60405180910390fd5b80607260008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254611a709190614e51565b925050819055503073ffffffffffffffffffffffffffffffffffffffff16633c004ae583848460026040518563ffffffff1660e01b8152600401611ab794939291906150c4565b600060405180830381600087803b158015611ad157600080fd5b505af1158015611ae5573d6000803e3d6000fd5b505050505050565b611af56140c6565b73ffffffffffffffffffffffffffffffffffffffff16611b13611d8b565b73ffffffffffffffffffffffffffffffffffffffff1614611b69576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611b6090615038565b60405180910390fd5b611b7360006140ce565b565b611b7d6140c6565b73ffffffffffffffffffffffffffffffffffffffff16611b9b611d8b565b73ffffffffffffffffffffffffffffffffffffffff1614611bf1576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611be890615038565b60405180910390fd5b8060688190555050565b600060019054906101000a900460ff16611c235760008054906101000a900460ff1615611c2c565b611c2b614194565b5b611c6b576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401611c629061517b565b60405180910390fd5b60008060019054906101000a900460ff161590508015611cbb576001600060016101000a81548160ff02191690831515021790555060016000806101000a81548160ff0219169083151502179055505b611cc36141a5565b600a6066819055506014606a81905550816067819055508260688190555083606560006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508015611d435760008060016101000a81548160ff0219169083151502179055505b50505050565b60706020528060005260406000206000915090505481565b606d6020528060005260406000206000915090508060000154908060010154908060020154905083565b6000603360009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905090565b60675481565b6000606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff166374cb38b06040518163ffffffff1660e01b8152600401602060405180830381865afa158015611e2a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611e4e9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff16636f853a5d6040518163ffffffff1660e01b81526004016020604051808303816000875af1158015611e9a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611ebe91906151b0565b9050611f4581607160008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206141fe565b611f8d81606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206141fe565b505050565b611f9a6140c6565b73ffffffffffffffffffffffffffffffffffffffff16611fb8611d8b565b73ffffffffffffffffffffffffffffffffffffffff161461200e576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161200590615038565b60405180910390fd5b80606560006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff16021790555050565b60695481565b6120606140c6565b73ffffffffffffffffffffffffffffffffffffffff1661207e611d8b565b73ffffffffffffffffffffffffffffffffffffffff16146120d4576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016120cb90615038565b60405180910390fd5b620f42408110612119576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161211090615229565b60405180910390fd5b8060678190555050565b60726020528060005260406000206000915090505481565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa1580156121a8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906121cc9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614612239576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161223090614bf6565b60405180910390fd5b606b6000600160695461224c9190614cc4565b815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16606b6000606c60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550606c60008273ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054606c6000606b600060016069546123629190614cc4565b815260200190815260200160002060009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002081905550606960008154809291906123e290614cf8565b919050555050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015612457573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061247b9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16146124e8576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016124df90614bf6565b60405180910390fd5b60008190506000607060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000205490505b606f60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020548110156128e157606e60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008281526020019081526020016000206001015482111561271957606e60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082815260200190815260200160002060010154826126339190614cc4565b9150606e60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828152602001908152602001600020600080820160006101000a81549073ffffffffffffffffffffffffffffffffffffffff0219169055600182016000905560028201600090555050607060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061270f90614c45565b91905055506128ce565b606e60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082815260200190815260200160002060010154820361285b57606e60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828152602001908152602001600020600080820160006101000a81549073ffffffffffffffffffffffffffffffffffffffff0219169055600182016000905560028201600090555050607060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061284d90614c45565b9190505550600091506128e1565b81606e60008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600083815260200190815260200160002060010160008282546128be9190614cc4565b92505081905550600091506128e1565b80806128d990614c45565b915050612532565b506000811115612aca5780607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600101600082825461297a9190614cc4565b9250508190555080606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060010160008282546129d39190614cc4565b9250508190555080607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254612a699190614cc4565b9250508190555080606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254612ac29190614cc4565b925050819055505b612c15606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663db9bee466040518163ffffffff1660e01b8152600401602060405180830381865afa158015612b3a573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612b5e9190614b6c565b83606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663afc1aaca6040518163ffffffff1660e01b8152600401602060405180830381865afa158015612bcc573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612bf09190614b6c565b73ffffffffffffffffffffffffffffffffffffffff166142259092919063ffffffff16565b505050565b606c6020528060005260406000206000915090505481565b606b6020528060005260406000206000915054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015612cd2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612cf69190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff161480612d5a57503073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16145b612d99576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612d9090614d96565b60405180910390fd5b80607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002015410158015612e285750600081115b612e67576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401612e5e90615295565b60405180910390fd5b80607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254612ef69190614cc4565b9250508190555080606d60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254612f4f9190614cc4565b92505081905550612f6083836142ab565b8173ffffffffffffffffffffffffffffffffffffffff168373ffffffffffffffffffffffffffffffffffffffff167fbf340c6e47f6acc1fa5fcad9ef75c1e4bd8d91e7313667c3c9859f230fc7f88383604051612fbd91906146ee565b60405180910390a3505050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa158015613037573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061305b9190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16146130c8576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016130bf90614bf6565b60405180910390fd5b607060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020548114613149576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161314090615301565b60405180910390fd5b607060008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600081548092919061319990614c45565b91905055506000606e60008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600083815260200190815260200160002060010154905060008111156133f857600061321160675483620f42406143b2565b9050600081836132219190614cc4565b90506000606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663afc1aaca6040518163ffffffff1660e01b8152600401602060405180830381865afa158015613292573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906132b69190614b6c565b90508073ffffffffffffffffffffffffffffffffffffffff166342966c68846040518263ffffffff1660e01b81526004016132f191906146ee565b600060405180830381600087803b15801561330b57600080fd5b505af115801561331f573d6000803e3d6000fd5b5050505061334e86838373ffffffffffffffffffffffffffffffffffffffff166142259092919063ffffffff16565b83607260008873ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600082825461339d9190614cc4565b925050819055508573ffffffffffffffffffffffffffffffffffffffff167f06c354c4c6161129e78d66f1af649af9142d80b5cd86bdcc2bac286b0d915ae583876040516133ec929190614d21565b60405180910390a25050505b505050565b606e602052816000526040600020602052806000526040600020600091509150508060000160009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16908060010154908060020154905083565b61345c6140c6565b73ffffffffffffffffffffffffffffffffffffffff1661347a611d8b565b73ffffffffffffffffffffffffffffffffffffffff16146134d0576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016134c790615038565b60405180910390fd5b8060668190555050565b600080607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff168152602001908152602001600020600101541480156135e957506000607160008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060020154145b905092915050565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1663ee7941d96040518163ffffffff1660e01b8152600401602060405180830381865afa15801561365e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906136829190614b6c565b73ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff1614806136e657503073ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff16145b613725576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161371c90614d96565b60405180910390fd5b60008111613768576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161375f9061536d565b60405180910390fd5b3073ffffffffffffffffffffffffffffffffffffffff1663d87db88584846040518363ffffffff1660e01b81526004016137a392919061538d565b602060405180830381865afa1580156137c0573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906137e491906153e2565b156139cd57607560008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054607460008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000208190555081607360008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000607560008773ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002054815260200190815260200160002060006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550607560008473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008154809291906139c790614c45565b91905055505b60003073ffffffffffffffffffffffffffffffffffffffff1663d87db88584856040518363ffffffff1660e01b8152600401613a0a92919061538d565b602060405180830381865afa158015613a27573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190613a4b91906153e2565b8015613a9957506000606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060010154145b8015613ae757506000606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060020154145b90508015613cf8578273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff1614613b5d576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401613b549061545b565b60405180910390fd5b81607160008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206001018190555081606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206001018190555081607160008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002018190555081606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060020181905550613de8565b81607160008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254613d879190614e51565b9250508190555081606d60008573ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206002016000828254613de09190614e51565b925050819055505b81607260008673ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff1681526020019081526020016000206000828254613e379190614e51565b92505081905550613e4884846142ab565b8273ffffffffffffffffffffffffffffffffffffffff168473ffffffffffffffffffffffffffffffffffffffff167f52467f14b857734001c77e6f125dac41b45798837c9fc9adfe3a5b394c77a0e984604051613ea591906146ee565b60405180910390a350505050565b6074602052816000526040600020602052806000526040600020600091509150505481565b60665481565b606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b60736020528160005260406000206020528060005260406000206000915091509054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b613f4e6140c6565b73ffffffffffffffffffffffffffffffffffffffff16613f6c611d8b565b73ffffffffffffffffffffffffffffffffffffffff1614613fc2576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401613fb990615038565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff1603614031576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401614028906154ed565b60405180910390fd5b61403a816140ce565b50565b6140c0846323b872dd60e01b85858560405160240161405e93929190614c8d565b604051602081830303815290604052907bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19166020820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff83818316178352505050506143d4565b50505050565b600033905090565b6000603360009054906101000a900473ffffffffffffffffffffffffffffffffffffffff16905081603360006101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff1602179055508173ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff167f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e060405160405180910390a35050565b600061419f3061449b565b15905090565b600060019054906101000a900460ff166141f4576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016141eb9061557f565b60405180910390fd5b6141fc6144be565b565b818160000154101561422157818160000181905550806002015481600101819055505b5050565b6142a68363a9059cbb60e01b848460405160240161424492919061559f565b604051602081830303815290604052907bffffffffffffffffffffffffffffffffffffffffffffffffffffffff19166020820180517bffffffffffffffffffffffffffffffffffffffffffffffffffffffff83818316178352505050506143d4565b505050565b6000606560009054906101000a900473ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16636f76e5f86040518163ffffffff1660e01b8152600401602060405180830381865afa15801561431a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061433e9190614b6c565b90508073ffffffffffffffffffffffffffffffffffffffff1663feaa1feb83856040518363ffffffff1660e01b815260040161437b92919061538d565b600060405180830381600087803b15801561439557600080fd5b505af11580156143a9573d6000803e3d6000fd5b50505050505050565b60008183856143c19190614f26565b6143cb91906155f7565b90509392505050565b6000614436826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c65648152508573ffffffffffffffffffffffffffffffffffffffff1661451f9092919063ffffffff16565b9050600081511115614496578080602001905181019061445691906153e2565b614495576040517f08c379a000000000000000000000000000000000000000000000000000000000815260040161448c9061569a565b60405180910390fd5b5b505050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b600060019054906101000a900460ff1661450d576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016145049061557f565b60405180910390fd5b61451d6145186140c6565b6140ce565b565b606061452e8484600085614537565b90509392505050565b60608247101561457c576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016145739061572c565b60405180910390fd5b6145858561464b565b6145c4576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016145bb90615798565b60405180910390fd5b6000808673ffffffffffffffffffffffffffffffffffffffff1685876040516145ed9190615832565b60006040518083038185875af1925050503d806000811461462a576040519150601f19603f3d011682016040523d82523d6000602084013e61462f565b606091505b509150915061463f82828661466e565b92505050949350505050565b6000808273ffffffffffffffffffffffffffffffffffffffff163b119050919050565b6060831561467e578290506146ce565b6000835111156146915782518084602001fd5b816040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016146c5919061589e565b60405180910390fd5b9392505050565b6000819050919050565b6146e8816146d5565b82525050565b600060208201905061470360008301846146df565b92915050565b600080fd5b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b60006147398261470e565b9050919050565b6147498161472e565b811461475457600080fd5b50565b60008135905061476681614740565b92915050565b6000806040838503121561478357614782614709565b5b600061479185828601614757565b92505060206147a285828601614757565b9150509250929050565b60006060820190506147c160008301866146df565b6147ce60208301856146df565b6147db60408301846146df565b949350505050565b6000602082840312156147f9576147f8614709565b5b600061480784828501614757565b91505092915050565b614819816146d5565b811461482457600080fd5b50565b60008135905061483681614810565b92915050565b60008060006060848603121561485557614854614709565b5b600061486386828701614757565b935050602061487486828701614757565b925050604061488586828701614827565b9150509250925092565b600080604083850312156148a6576148a5614709565b5b60006148b485828601614757565b92505060206148c585828601614827565b9150509250929050565b600481106148dc57600080fd5b50565b6000813590506148ee816148cf565b92915050565b6000806000806080858703121561490e5761490d614709565b5b600061491c87828801614757565b945050602061492d87828801614757565b935050604061493e87828801614827565b925050606061494f878288016148df565b91505092959194509250565b60006020828403121561497157614970614709565b5b600061497f84828501614827565b91505092915050565b6149918161472e565b82525050565b60006020820190506149ac6000830184614988565b92915050565b60006149bd8261472e565b9050919050565b6149cd816149b2565b81146149d857600080fd5b50565b6000813590506149ea816149c4565b92915050565b600080600060608486031215614a0957614a08614709565b5b6000614a17868287016149db565b9350506020614a2886828701614827565b9250506040614a3986828701614827565b9150509250925092565b600060208284031215614a5957614a58614709565b5b6000614a67848285016149db565b91505092915050565b6000606082019050614a856000830186614988565b614a9260208301856146df565b614a9f60408301846146df565b949350505050565b60008115159050919050565b614abc81614aa7565b82525050565b6000602082019050614ad76000830184614ab3565b92915050565b6000819050919050565b6000614b02614afd614af88461470e565b614add565b61470e565b9050919050565b6000614b1482614ae7565b9050919050565b6000614b2682614b09565b9050919050565b614b3681614b1b565b82525050565b6000602082019050614b516000830184614b2d565b92915050565b600081519050614b6681614740565b92915050565b600060208284031215614b8257614b81614709565b5b6000614b9084828501614b57565b91505092915050565b600082825260208201905092915050565b7f4730303700000000000000000000000000000000000000000000000000000000600082015250565b6000614be0600483614b99565b9150614beb82614baa565b602082019050919050565b60006020820190508181036000830152614c0f81614bd3565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b6000614c50826146d5565b91507fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff8203614c8257614c81614c16565b5b600182019050919050565b6000606082019050614ca26000830186614988565b614caf6020830185614988565b614cbc60408301846146df565b949350505050565b6000614ccf826146d5565b9150614cda836146d5565b925082821015614ced57614cec614c16565b5b828203905092915050565b6000614d03826146d5565b915060008203614d1657614d15614c16565b5b600182039050919050565b6000604082019050614d3660008301856146df565b614d4360208301846146df565b9392505050565b7f4730303800000000000000000000000000000000000000000000000000000000600082015250565b6000614d80600483614b99565b9150614d8b82614d4a565b602082019050919050565b60006020820190508181036000830152614daf81614d73565b9050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b7f5330303600000000000000000000000000000000000000000000000000000000600082015250565b6000614e1b600483614b99565b9150614e2682614de5565b602082019050919050565b60006020820190508181036000830152614e4a81614e0e565b9050919050565b6000614e5c826146d5565b9150614e67836146d5565b9250827fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff03821115614e9c57614e9b614c16565b5b828201905092915050565b60048110614eb857614eb7614db6565b5b50565b6000819050614ec982614ea7565b919050565b6000614ed982614ebb565b9050919050565b614ee981614ece565b82525050565b6000606082019050614f0460008301866146df565b614f1160208301856146df565b614f1e6040830184614ee0565b949350505050565b6000614f31826146d5565b9150614f3c836146d5565b9250817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0483118215151615614f7557614f74614c16565b5b828202905092915050565b7f5330303200000000000000000000000000000000000000000000000000000000600082015250565b6000614fb6600483614b99565b9150614fc182614f80565b602082019050919050565b60006020820190508181036000830152614fe581614fa9565b9050919050565b7f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572600082015250565b6000615022602083614b99565b915061502d82614fec565b602082019050919050565b6000602082019050818103600083015261505181615015565b9050919050565b7f4730303300000000000000000000000000000000000000000000000000000000600082015250565b600061508e600483614b99565b915061509982615058565b602082019050919050565b600060208201905081810360008301526150bd81615081565b9050919050565b60006080820190506150d96000830187614988565b6150e66020830186614988565b6150f360408301856146df565b6151006060830184614ee0565b95945050505050565b7f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160008201527f647920696e697469616c697a6564000000000000000000000000000000000000602082015250565b6000615165602e83614b99565b915061517082615109565b604082019050919050565b6000602082019050818103600083015261519481615158565b9050919050565b6000815190506151aa81614810565b92915050565b6000602082840312156151c6576151c5614709565b5b60006151d48482850161519b565b91505092915050565b7f5330303100000000000000000000000000000000000000000000000000000000600082015250565b6000615213600483614b99565b915061521e826151dd565b602082019050919050565b6000602082019050818103600083015261524281615206565b9050919050565b7f5330303500000000000000000000000000000000000000000000000000000000600082015250565b600061527f600483614b99565b915061528a82615249565b602082019050919050565b600060208201905081810360008301526152ae81615272565b9050919050565b7f5330303900000000000000000000000000000000000000000000000000000000600082015250565b60006152eb600483614b99565b91506152f6826152b5565b602082019050919050565b6000602082019050818103600083015261531a816152de565b9050919050565b7f5330303300000000000000000000000000000000000000000000000000000000600082015250565b6000615357600483614b99565b915061536282615321565b602082019050919050565b600060208201905081810360008301526153868161534a565b9050919050565b60006040820190506153a26000830185614988565b6153af6020830184614988565b9392505050565b6153bf81614aa7565b81146153ca57600080fd5b50565b6000815190506153dc816153b6565b92915050565b6000602082840312156153f8576153f7614709565b5b6000615406848285016153cd565b91505092915050565b7f5330303400000000000000000000000000000000000000000000000000000000600082015250565b6000615445600483614b99565b91506154508261540f565b602082019050919050565b6000602082019050818103600083015261547481615438565b9050919050565b7f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160008201527f6464726573730000000000000000000000000000000000000000000000000000602082015250565b60006154d7602683614b99565b91506154e28261547b565b604082019050919050565b60006020820190508181036000830152615506816154ca565b9050919050565b7f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960008201527f6e697469616c697a696e67000000000000000000000000000000000000000000602082015250565b6000615569602b83614b99565b91506155748261550d565b604082019050919050565b600060208201905081810360008301526155988161555c565b9050919050565b60006040820190506155b46000830185614988565b6155c160208301846146df565b9392505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b6000615602826146d5565b915061560d836146d5565b92508261561d5761561c6155c8565b5b828204905092915050565b7f5361666545524332303a204552433230206f7065726174696f6e20646964206e60008201527f6f74207375636365656400000000000000000000000000000000000000000000602082015250565b6000615684602a83614b99565b915061568f82615628565b604082019050919050565b600060208201905081810360008301526156b381615677565b9050919050565b7f416464726573733a20696e73756666696369656e742062616c616e636520666f60008201527f722063616c6c0000000000000000000000000000000000000000000000000000602082015250565b6000615716602683614b99565b9150615721826156ba565b604082019050919050565b6000602082019050818103600083015261574581615709565b9050919050565b7f416464726573733a2063616c6c20746f206e6f6e2d636f6e7472616374000000600082015250565b6000615782601d83614b99565b915061578d8261574c565b602082019050919050565b600060208201905081810360008301526157b181615775565b9050919050565b600081519050919050565b600081905092915050565b60005b838110156157ec5780820151818401526020810190506157d1565b838111156157fb576000848401525b50505050565b600061580c826157b8565b61581681856157c3565b93506158268185602086016157ce565b80840191505092915050565b600061583e8284615801565b915081905092915050565b600081519050919050565b6000601f19601f8301169050919050565b600061587082615849565b61587a8185614b99565b935061588a8185602086016157ce565b61589381615854565b840191505092915050565b600060208201905081810360008301526158b88184615865565b90509291505056fea2646970667358221220ec252dc524022b8b5bee4ebd52c3bae11b4c0f7980f96ce6a2b74c7be324974364736f6c634300080f0033";
const isSuperArgs = (xs) => xs.length > 1;
class Staking__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "Staking";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Staking__factory = Staking__factory;
Staking__factory.bytecode = _bytecode;
Staking__factory.abi = _abi;
